export default function IndexController() {

}